import React from 'react';
import { connect } from 'react-redux';
import RegistrationForm from './RegistrationForm';
import classes from './RegistrationView.scss';
import api from '../../../utils/api';
import { fromJS } from 'immutable';

import LinearProgress from 'material-ui/LinearProgress';

import { detect } from 'detect-browser';
import { Col, Row } from 'react-flexbox-grid';

const browser = detect();

class RegistrationView extends React.Component {
    onSubmit = values => {
        values = values.toJS();
        values.zip_code = '' + values.zip_code;
        this.props.register({
            user: Object.assign(
                { host: window.location.protocol + '//' + window.location.host },
                values,
                {}
            ),
        });
    };

    invalidContent = () => {
        return (
            <div style={{ padding: '40px', textAlign: 'center' }}>
                Diese Seite ist nur kompatibel mit{' '}
                <a href="https://www.google.de/chrome/browser/desktop/">Chrome</a> oder{' '}
                <a href="https://www.mozilla.org/de/firefox/new/">Firefox</a>.
            </div>
        );
    };

    renderValidContent = () => {
        let style = {
            opacity: 1,
        };
        if (this.props.isFetching === true) {
            style = {
                opacity: 0.25,
                pointerEvents: 'none',
            };
        }

        return (
            <div>
                <h1>Registrierung</h1>
                {this.props.isFetching && (
                    <Row>
                        <Col md={12} sm={12} xs={12}>
                            <LinearProgress
                                mode="indeterminate"
                                color="#3babd0"
                                style={{
                                    left: '0px',
                                    height: '10px',
                                    top: '63px',
                                    right: '0px',
                                    position: 'absolute',
                                }}
                            />
                        </Col>
                    </Row>
                )}
                <div style={style}>
                    <RegistrationForm onSubmit={this.onSubmit} errors={this.props.errors} />
                </div>
            </div>
        );
    };

    render = () => {
        const validBrowser =
            browser.name === 'chrome' ||
            browser.name === 'firefox' ||
            browser.name === 'safari' ||
            browser.name === 'edge';

        return (
            <div className={classes.container}>
                {validBrowser && this.renderValidContent()}
                {!validBrowser && this.invalidContent()}
            </div>
        );
    };
}

const mapStateToProps = (state, props) => ({
    isFetching: state.registration.get('isFetching'),
    errors: state.registration.get('errors') || fromJS({}),
});

const mapDispatchToProps = dispatch => ({
    register: payload => dispatch(api.actions.registration.register(payload)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RegistrationView);
